import Wrapper from "../../Wrapper";

 const TripControlPayroll = ()=>{
     return (
         <>
         <Wrapper>
            <h3 style={{textAlign: "center",position: "relative", top: "50px", color:"#bf2527"}}>Trip Control Payroll</h3>
         </Wrapper>
         </>
     );
 }
 export default TripControlPayroll;